import * as React from 'react';
import {SessionRunTestsConfirm as RunTestsConfirm} from '../run-tests-confirm/run-tests-confirm';
import {SessionRunTestsAlert as RunTestsAlert} from '../run-tests-alert/run-tests-alert';
import {SessionEditorRunTests} from '../../session-editor/run-tests/run-tests';
import './styles.sass';

export interface ISessionRunTestsProps {
  hadTestsUnlocked: boolean;
  isInterviewer: boolean;
  onClick: (code: string) => void;
}

export interface ISessionRunTestsState {
  isOpen: boolean;
}

export class SessionRunTests extends React.Component<ISessionRunTestsProps, ISessionRunTestsState> {
  public state: ISessionRunTestsState = {
    isOpen: false,
  };

  private editorValue: string;

  public render(): React.ReactElement<any> {
    const {isInterviewer} = this.props;
    const {isOpen} = this.state;

    return (
      <div className={'session-run-tests'}>
         <SessionEditorRunTests onClick={this.onClick} />

         {
           isInterviewer
             ? <RunTestsAlert isOpen={isOpen} onClose={() => this.closeConfirmModal(false)} />
             : <RunTestsConfirm isOpen={isOpen} onClose={this.closeConfirmModal} />
         }
       </div>
    );
  }

  private showConfirmModal = (): void => {
    this.setState({isOpen: true});
  };

  private closeConfirmModal = (result: boolean): void => {
    this.setState({isOpen: false});

    if (result) {
      this.props.onClick(this.editorValue);
    }
  };

  private onClick = (editorValue: string) => {
    const {
      hadTestsUnlocked,
      onClick,
    } = this.props;

    hadTestsUnlocked
      ? onClick(editorValue)
      : this.showConfirmModal();

    this.editorValue = editorValue;
  }
}
